import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import CaretIcon from 'modules/Common/components/svg/CaretIcon';

export default function CaretLink(props) {
  require("./CaretLink.scss");

  const {
    to: linkTo,
    className: parentClass = "",
    caretDirection: direction = "right",
    children: children
  } = props;

  return (
    <Link className={`caret-link ${parentClass}`} to={linkTo}><CaretIcon type="full" direction={direction}/>{children}</Link>
  )
}

CaretLink.propTypes = {
  to: PropTypes.string,
  className: PropTypes.string,
  caretDirection: PropTypes.string,
  children: PropTypes.any
};



// WEBPACK FOOTER //
// ./modules/Common/components/CaretLink.js